import { render, staticRenderFns } from "./EditAdmins.vue?vue&type=template&id=fcdb5e92&scoped=true&"
import script from "./EditAdmins.vue?vue&type=script&lang=js&"
export * from "./EditAdmins.vue?vue&type=script&lang=js&"
import style0 from "./EditAdmins.vue?vue&type=style&index=0&id=fcdb5e92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdb5e92",
  null
  
)

export default component.exports